<template>
  <aside class="sidebar" :class="{ 'mobile-open': mobileOpen }">
    <div class="sidebar-tabs">
      <button
        class="tab-item"
        :class="{ active: activeTab === 'assistant' }"
        @click="$emit('tab-change', 'assistant')"
      >
        助手
      </button>
      <button
        class="tab-item"
        :class="{ active: activeTab === 'topic' }"
        @click="$emit('tab-change', 'topic')"
      >
        话题
      </button>
    </div>

    <div class="sidebar-content">
      <!-- 助手列表 -->
      <div v-show="activeTab === 'assistant'" class="list-panel">
        <button
          class="add-btn"
          :class="{ active: assistantStoreOpen }"
          @click="handleAddAssistantClick"
        >
          <span class="add-icon">+</span>
          添加助手
        </button>
        <ul class="item-list">
          <li
            v-for="item in assistants"
            :key="item.id"
            class="list-item"
            :class="{ active: item.id === selectedAssistantId }"
            @click="$emit('select-assistant', item.id)"
          >
            <span class="item-icon">{{ item.icon }}</span>
            <span class="item-name">{{ item.name }}</span>
            <button
              v-if="item.id === selectedAssistantId"
              class="more-btn"
              @click.stop="showMenu($event, 'assistant', item.id)"
            >
              ⋮
            </button>
          </li>
        </ul>
      </div>

      <!-- 话题列表 -->
      <div v-show="activeTab === 'topic'" class="list-panel">
        <button class="add-btn" @click="$emit('add-topic')">
          <span class="add-icon">+</span>
          新建话题
        </button>
        <div v-if="topics.length === 0" class="empty-tip">
          暂无话题，点击上方新建
        </div>
        <ul v-else class="item-list">
          <li
            v-for="item in topics"
            :key="item.id"
            class="list-item"
            :class="{ active: item.id === selectedTopicId }"
            @click="$emit('select-topic', item.id)"
          >
            <span class="item-icon topic-icon">💬</span>
            <div class="item-info">
              <span class="item-name">{{ item.title }}</span>
              <span class="item-time">{{ formatTime(item.updatedAt) }}</span>
            </div>
            <button
              v-if="item.id === selectedTopicId"
              class="more-btn"
              @click.stop="showMenu($event, 'topic', item.id)"
            >
              ⋮
            </button>
          </li>
        </ul>
      </div>
    </div>

    <!-- 底部用户信息 -->
    <div class="user-bar" @click="handleUserClick">
      <div class="user-avatar">
        <img v-if="user.isLoggedIn && user.avatar" :src="user.avatar" alt="头像" />
        <span v-else class="default-avatar">
          {{ user.isLoggedIn ? user.nickname.charAt(0).toUpperCase() : '?' }}
        </span>
      </div>
      <div class="user-info">
        <span class="user-name">{{ user.isLoggedIn ? user.nickname : '未登录' }}</span>
        <span class="user-status">{{ user.isLoggedIn ? '已登录' : '点击登录' }}</span>
      </div>
      <button
        v-if="user.isLoggedIn"
        class="logout-btn"
        title="退出登录"
        @click.stop="handleLogout"
      >
        <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor">
          <path d="M17 7l-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.58L17 17l5-5zM4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4V5z"/>
        </svg>
      </button>
    </div>

    <!-- 右键菜单 -->
    <div
      v-if="menuVisible"
      class="context-menu"
      :class="{ wide: menuType === 'assistant' }"
      :style="{ top: menuY + 'px', left: menuX + 'px' }"
    >
      <!-- 助手专属菜单 -->
      <template v-if="menuType === 'assistant'">
        <button class="menu-item" @click.stop="handleEditAssistant">
          <span class="m-icon">✏️</span>
          <span>编辑助手</span>
        </button>
<!--        <button class="menu-item" @click.stop="handleClearTopics">-->
<!--          <span class="m-icon">🗑</span>-->
<!--          <span>清空话题</span>-->
<!--        </button>-->
        <div class="menu-divider"></div>
        <button class="menu-item danger" @click.stop="handleDelete">
          <span class="m-icon">🗑️</span>
          <span>删除</span>
        </button>
      </template>

      <!-- 话题专属菜单 -->
      <template v-else>
        <button class="menu-item" @click.stop="handleEditTopic">
          <span class="m-icon">✏️</span>
          <span>编辑</span>
        </button>
        <button class="menu-item danger" @click.stop="handleDelete">
          <span class="m-icon">🗑️</span>
          <span>删除</span>
        </button>
      </template>
    </div>
  </aside>
</template>

<script>
import { formatTime } from '../utils/helpers'

export default {
  name: 'Sidebar',
  props: {
    activeTab: { type: String, default: 'assistant' },
    assistants: { type: Array, default: () => [] },
    topics: { type: Array, default: () => [] },
    selectedAssistantId: { type: [Number, String], default: null },
    selectedTopicId: { type: [Number, String], default: null },
    assistantStoreOpen: { type: Boolean, default: false },
    mobileOpen: { type: Boolean, default: false },
    isLoggedIn: { type: Boolean, default: false },
    user: { type: Object, default: () => ({ isLoggedIn: false, nickname: '未登录', email: '', avatar: '' }) }
  },
  data() {
    return {
      menuVisible: false,
      menuX: 0,
      menuY: 0,
      menuType: '',
      menuId: null
    }
  },
  mounted() {
    document.addEventListener('click', this.hideMenu)
  },
  beforeDestroy() {
    document.removeEventListener('click', this.hideMenu)
  },
  methods: {
    formatTime,
    showMenu(e, type, id) {
      const rect = e.currentTarget.getBoundingClientRect()
      this.menuX = rect.right - (type === 'assistant' ? 170 : 110)
      this.menuY = rect.bottom + 4
      this.menuType = type
      this.menuId = id
      this.menuVisible = true
    },
    hideMenu() {
      this.menuVisible = false
    },
    handleAddAssistantClick() {
      this.$emit('add-assistant')
    },
    // ========== 用户操作 ==========
    handleUserClick() {
      if (this.isLoggedIn) return
      this.$emit('show-login')
    },
    handleLogout() {
      this.$emit('logout')
    },
    // ========== 助手菜单 ==========
    handleEditAssistant() {
      this.$emit('edit-assistant', this.menuId)
      this.hideMenu()
    },
    handleCopyAssistant() {
      this.$emit('copy-assistant', this.menuId)
      this.hideMenu()
    },
    handleClearTopics() {
      this.$emit('clear-assistant-topics', this.menuId)
      this.hideMenu()
    },
    handleSaveToLibrary() {
      this.$emit('save-assistant-library', this.menuId)
      this.hideMenu()
    },
    handleIconChange() {
      this.$emit('change-assistant-icon', this.menuId)
      this.hideMenu()
    },
    handleSort(order) {
      this.$emit('sort-assistants', order)
      this.hideMenu()
    },
    // ========== 话题菜单 ==========
    handleEditTopic() {
      this.$emit('edit-topic', this.menuId)
      this.hideMenu()
    },
    // ========== 通用删除 ==========
    handleDelete() {
      if (this.menuType === 'assistant') {
        this.$emit('delete-assistant', this.menuId)
      } else {
        this.$emit('delete-topic', this.menuId)
      }
      this.hideMenu()
    }
  }
}
</script>

<style scoped>
.sidebar {
  width: 260px;
  min-width: 260px;
  background: #fff;
  border-right: 1px solid #e8e8e8;
  display: flex;
  flex-direction: column;
  position: relative;
}

.sidebar-tabs {
  display: flex;
  border-bottom: 1px solid #e8e8e8;
  padding: 0 16px;
}

.tab-item {
  flex: 1;
  padding: 14px 0;
  font-size: 14px;
  color: #666;
  position: relative;
  transition: color 0.2s;
}

.tab-item:hover {
  color: #333;
}

.tab-item.active {
  color: #1a9c8e;
  font-weight: 500;
}

.tab-item.active::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 40px;
  height: 2px;
  background: #1a9c8e;
  border-radius: 1px;
}

.sidebar-content {
  flex: 1;
  overflow-y: auto;
  padding: 8px 0;
}

.list-panel {
  padding: 0 8px;
}

.add-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  width: 100%;
  padding: 10px 12px;
  color: #666;
  font-size: 14px;
  border-radius: 8px;
  transition: background 0.2s;
}

.add-btn:hover {
  background: #f5f5f5;
  color: #333;
}

.add-btn.active {
  background: #e6f7f5;
  color: #1a9c8e;
}

.add-btn.disabled {
  color: #999;
  opacity: 0.8;
  cursor: not-allowed;
}

.add-btn.disabled:hover {
  background: #f5f5f5;
  color: #777;
}

.add-icon {
  font-size: 16px;
  font-weight: 300;
}

.item-list {
  list-style: none;
  margin-top: 4px;
}

.list-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.2s;
  position: relative;
}

.list-item:hover {
  background: #f5f5f5;
}

.list-item.active {
  background: #ebebeb;
}

.item-icon {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  flex-shrink: 0;
}

.topic-icon {
  font-size: 16px;
}

.item-info {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.item-name {
  font-size: 14px;
  color: #333;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.item-time {
  font-size: 12px;
  color: #999;
}

.more-btn {
  width: 24px;
  height: 24px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;
  font-size: 14px;
  flex-shrink: 0;
}

.more-btn:hover {
  background: rgba(0, 0, 0, 0.06);
  color: #666;
}

.empty-tip {
  padding: 32px 16px;
  text-align: center;
  color: #999;
  font-size: 13px;
}

.context-menu {
  position: fixed;
  z-index: 1000;
  background: #fff;
  border: 1px solid #e8e8e8;
  border-radius: 10px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  padding: 6px;
  min-width: 110px;
  animation: fadeIn 0.12s ease;
}

.context-menu.wide {
  min-width: 180px;
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(-4px); }
  to { opacity: 1; transform: translateY(0); }
}

.menu-item {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 8px 12px;
  text-align: left;
  font-size: 13px;
  color: #333;
  border-radius: 6px;
  white-space: nowrap;
}

.menu-item:hover {
  background: #f3f4f6;
}

.m-icon {
  width: 18px;
  text-align: center;
  font-size: 14px;
}

.menu-divider {
  height: 1px;
  background: #f0f0f0;
  margin: 4px 6px;
}

.menu-item.danger {
  color: #e74c3c;
}

.menu-item.danger:hover {
  background: #fef0ef;
}

/* ====== 底部用户信息 ====== */
.user-bar {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  border-top: 1px solid #f0f0f0;
  cursor: pointer;
  transition: background 0.2s;
  flex-shrink: 0;
}

.user-bar:hover {
  background: #f5f5f5;
}

.user-avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  overflow: hidden;
  flex-shrink: 0;
  background: #e0e0e0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.user-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.default-avatar {
  font-size: 16px;
  font-weight: 600;
  color: #999;
}

.user-info {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.user-name {
  font-size: 14px;
  color: #333;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.user-status {
  font-size: 12px;
  color: #999;
}

.logout-btn {
  width: 28px;
  height: 28px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;
  flex-shrink: 0;
  transition: all 0.2s;
}

.logout-btn:hover {
  background: #fef0ef;
  color: #e74c3c;
}

/* ====== 移动端 ≤768px ====== */
@media (max-width: 768px) {
  .sidebar {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    width: 280px;
    max-width: 85vw;
    z-index: 1000;
    transform: translateX(-100%);
    transition: transform 0.28s cubic-bezier(0.4, 0, 0.2, 1);
    box-shadow: 2px 0 16px rgba(0, 0, 0, 0.08);
  }

  .sidebar.mobile-open {
    transform: translateX(0);
  }

  .sidebar-tabs {
    padding-top: env(safe-area-inset-top, 0);
  }

  .user-bar {
    padding-bottom: calc(10px + env(safe-area-inset-bottom, 0));
  }
}

/* ====== 平板 769px~1024px ====== */
@media (min-width: 769px) and (max-width: 1024px) {
  .sidebar {
    width: 220px;
    min-width: 220px;
  }
}
</style>
